'use strict'
module.exports = {
  NODE_ENV: '"production"',
	// LOCAL_FACADE_SERVER_FULL_ADDRESS: '"https://dev.finvasia.com:9000"',//to access locally
	LOCAL_FACADE_SERVER_FULL_ADDRESS: '"https://dev-prism-api.shoonya.com"',

	WhatsApplink : '"https://api.whatsapp.com/send?text=Open a Prism account and start investing today! "',
	Facebooklink1 : '"https://www.facebook.com/sharer/sharer.php?u="',
	Facebooklink2 : '"&quote=Open a Prism account and start investing today!"',
	Twitterlink1 : '"https://twitter.com/intent/tweet?text=Open a Prism account and start investing today&url="',
	Twitterlink2 : '"&related="',
	LinkedInlink1 : '"https://www.linkedin.com/shareArticle?mini=true&url="',
	LinkedInlink2 : '"&title=&summary=&source="',

	//==========
	monthlydataJson : {
		heading : {0:"'SN'", 1: "'Received from'", 2:"'Carried forward from previous month'", 3:"'Received during the month'", 4:"'Total Pending'", 5:"'Resolved*'",6 : "'Pending at the end of the month**'", 7 : "'Average Resoluti on time^ (in days)'"},
		receivedFrom : {
			'Directly from Investors' : {},
			'SEBI(SCORES)' : {},
			'Stock Exchanges' : {},
			'Other Sources(if any)' : {},
		}
	},
	monthlydisposalJson : {
		heading : {0:"'SN'", 1: "'Month'", 2:"'Carried forward from previous month'", 3:"'Received'", 4:"'Resolved*'", 5:"'Pending**'"},
		monthlyData : {
			April : {},
			May : {},
			June : {},
			July : {},
			August : {},
			September : {},
			October : {},
			November : {},
			December : {},
			January : {},
			February : {},
			March : {},

		}
	},
	annualdisposalJson : {
		heading : {0:"'SN'", 1: "'Year'", 2:"'Carried forward from previous month'", 3:"'Received during the year'", 4:"'Resolved during the year'", 5:"'Pending at the end of the year'"},
		annaulData : {
			'2017-18' : {},
			'2018-19' : {},
			'2019-20' : {},
			'2020-21' : {},
			'2021-22' : {},
			
		}
	},
	VITE_CRYPTO_ENCRYPTION_KEY_LEAD:'"5c0b7333c2db54464195843b9bbbadb769cc71f7ccbdfca9956ba61260b48cf5"',
	VITE_CRYPTO_ENCRYPTION_IV_LEAD:'"aa3c74a66970649150af42d02f4942fb"',
	VITE_CAPTCHA_KEY:'"6Lcjw_4pAAAAAPefhIKvjNfLNu8A-JXAO0gDExzp"',
}


//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 59